import { Component, effect, input } from '@angular/core';

@Component({
  selector: 'phoenix-json-viewer',
  template: `
    <ngx-json-viewer
      [json]="safeJson"
      [expanded]="isExpanded"
      class="json-record"
    ></ngx-json-viewer>
  `,
  standalone: false,
})
export class JsonViewerComponent {
  json = input({});
  safeJson: any = {};
  isExpanded = false;

  constructor() {
    effect(() => {
      try {
        const raw = this.json();
        const cleaned = JSON.stringify(raw, (_, value) =>
          typeof value === 'bigint' ? value.toString() : value
        );
        this.safeJson = JSON.parse(cleaned);

        this.isExpanded = cleaned.length < 10000;
      } catch (err) {
        this.isExpanded = false;
      }
    });
  }
}
